import type { CallCenterV3Types } from "@EspaceParkQC/sdk-services-legacy";

export default function IntercomParty({
  intercomPartyDetails,
}: {
  intercomPartyDetails: CallCenterV3Types.CallPartyParkingIntercom | undefined;
}): React.ReactElement | null {
  if (!intercomPartyDetails) return null;
  const line1 = intercomPartyDetails?.parkData?.address?.line1;
  const nickname = intercomPartyDetails?.parkData?.nickname;
  const name = intercomPartyDetails.extension.name;

  return (
    <div className="space-y-1 md:pt-6 pt-3 mb-4">
      <h1 className="text-lg font-bold">{nickname && line1 ? `${nickname} (${line1})` : nickname || line1}</h1>
      <p className="text-sm">
        <span className="font-bold">{name}</span> ({intercomPartyDetails.extension.number})
      </p>
    </div>
  );
}
